import type { DwgScanUpload } from "@plan-forge/templatecreator-contract";
import { ApiError } from "./api.ts";

/** Reads a 03 .dwg in a Web Worker. The drawing never leaves the browser. */
export async function scanDwgFile(file: File): Promise<DwgScanUpload> {
  if (!file.name.toLowerCase().endsWith(".dwg")) {
    throw new ApiError([`${file.name} is not a .dwg file.`]);
  }
  const bytes = await file.arrayBuffer();
  const worker = new Worker(new URL("./dwg-scan.worker.ts", import.meta.url), { type: "module" });
  try {
    return await new Promise<DwgScanUpload>((resolve, reject) => {
      worker.onmessage = (event: MessageEvent<{ scan?: DwgScanUpload; error?: string }>) => {
        if (event.data.scan !== undefined) resolve(event.data.scan);
        else reject(new ApiError([event.data.error ?? "The drawing could not be read."]));
      };
      worker.onerror = () => reject(new ApiError(["The drawing reader failed to start."]));
      worker.postMessage(bytes, [bytes]);
    });
  } finally {
    worker.terminate();
  }
}
